var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SelectBoxArea"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('SelectBox',{attrs:{"item-list":_vm.itemList,"initialValue":_vm.initialValue},on:{"change-value":_vm.changeValue}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12bc739b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Atoms/SelectBoxArea.vue
// module id = null
// module chunks = 